import { CompetencyStatus, UserCompetency, isPendingLikeStatus } from 'app/_models/competency.model';

export interface CompetencyFilterOption {
  key: string;
  label: string;
  class: string;
}

export const MANAGE_WORKER_COMPETENCY_STATUS_BUTTONS: CompetencyFilterOption[] = [
  { key: '', label: 'All', class: 'primary' },
  { key: 'VALID', label: 'Valid', class: 'success' },
  { key: 'EXPIRED', label: 'Expired', class: 'danger' },
  { key: 'UNVERIFIED', label: 'Unverified', class: 'unverified' },
  { key: 'REJECTED', label: 'Rejected', class: 'danger' },
];

export const WORKER_SELF_COMPETENCY_STATUS_BUTTONS: CompetencyFilterOption[] = [
  { key: '', label: 'All', class: 'primary' },
  { key: 'VALID', label: 'Valid', class: 'success' },
  { key: 'EXPIRED', label: 'Expired', class: 'danger' },
  { key: 'EVIDENCE_REQUESTED', label: 'Evidence Requested', class: 'unverified' },
  { key: 'UNVERIFIED', label: 'Unverified', class: 'unverified' },
  { key: 'REJECTED', label: 'Rejected', class: 'danger' },
];

export const COMPETENCY_CATEGORY_BUTTONS: CompetencyFilterOption[] = [
  { key: '', label: 'All', class: 'primary' },
  { key: 'Turbine', label: 'Turbine', class: 'turbine' },
  { key: 'Site', label: 'Site', class: 'site' },
];

export function matchesCompetencyStatus(filterStatus: string, competency: UserCompetency): boolean {
  if (!filterStatus) {
    return true;
  }

  switch (filterStatus) {
    case 'VALID':
      return competency.status === CompetencyStatus.Approved;
    case 'EXPIRED':
      return competency.status === CompetencyStatus.Expired;
    case 'EVIDENCE_REQUESTED':
      return competency.status === CompetencyStatus.DocumentRequested;
    case 'UNVERIFIED':
      return isPendingLikeStatus(competency.status);
    case 'REJECTED':
      return competency.status === CompetencyStatus.Rejected;
    default:
      return true;
  }
}

export function matchesCompetencyCategory(filterCategory: string, competency: UserCompetency): boolean {
  if (!filterCategory) {
    return true;
  }

  if (!competency.type) {
    return false;
  }

  return competency.type.toLowerCase() === filterCategory.toLowerCase();
}
